<script setup>
import { formattedDate, getAgeFromRange } from '@/helper';
import { ref, onMounted } from 'vue';

const props = defineProps({
  item: {
    type: Object,
    required: true
  },
  child: {
    type: Object,
    required: true
  }
})

const isAssessment = ref(false)
function get_title(item){
  let title = ''
  if (item?.type == 'assessment_progress'){
    isAssessment.value = true
    if (item.attributes.is_completed){
      title = 'Completed Assessment'
    }else{
      title = 'Ongoing Assessment'
    }
  }else{
    if (item?.attributes.is_completed){
      title = 'Completed Intervention'
    }else{
      title = 'Ongoing Intervention'
    }
  }
  return title
}

function get_age_done(){
  let age = ''
  // console.log("🚀 ~ get_age_done ~ props.child:", props.child)
  let age_done = getAgeFromRange(props.child?.attributes.date_of_birth, props.item?.attributes.updated_at)
  return age_done
}
</script>

<template>
  <div class="card no-shadow border p-0 my-2">
    <div class="card-body py-2 row">
      <div class="col-6 d-flex align-items-center">
        <div>
          <p class="m-0 p-0 fw-medium tracking-wide">
            {{ get_title(item) }}
          </p>
          <p class="secondary-text">
            Done at : {{ get_age_done() }} years old
          </p>
        </div>
      </div>
  
      <div class="col-3 d-flex align-items-center">
        <div 
          :class="isAssessment ? 'assessment-pill' : 'intervention-pill'"
        >
          {{ isAssessment ? 'Assessment' : 'Intervention' }}
        </div>
      </div>
  
      <div class="col-3 d-flex align-items-center">
        <p>{{ formattedDate(item?.attributes.updated_at)}}</p>
      </div>
    </div>
  </div>
</template>